import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Landing from "./views/Landing";
import "./components/MainArea";
import StoreFront from "./views/StoreFront";
import Checkout from "./views/Checkout";
import Login from "./views/Login";
import MyProjects from "./views/MyProjects";
import { auth } from "./firebase";
import { useStateValue } from "./Stateprovider";
import { db } from "./firebase";
function App() {
  const [{ locked, user }, dispatch] = useStateValue();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.

        dispatch({
          type: "SET_USER",
          user: user,
        });
        db.collection("users")
          .doc(user?.uid)
          .collection("projects")
          // .orderBy("created", "desc")
          .onSnapshot((snapshot) =>
            setProjects(
              snapshot.docs.map((doc) => ({
                id: doc.id,
                data: doc.data(),
              }))
            )
          );
      } else {
        // User is signed out.
        console.log("Signed out");
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);

  useEffect(() => {
    projects.map((doc) =>
      dispatch({ type: "ADD_TO_LOCKED", item: doc.data.id })
    );
    dispatch({ type: "SET_PROJECTS", item: projects });
    console.log("PROJO ", projects);
  }, [projects]);

  return (
    <Router>
      <div>
        <Switch>
          <Route path="/storefront">
            <StoreFront></StoreFront>
          </Route>
          <Route path="/myprojects">
            <MyProjects></MyProjects>
          </Route>
          <Route path="/cart">
            <Checkout></Checkout>
          </Route>
          <Route path="/logout">
            {/* <Header /> */}
            <h1>Logout</h1>
          </Route>
          <Route path="/login">
            <Login></Login>
          </Route>

          <Route path="/">
            {/* <Header /> */}
            <Landing></Landing>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
